import { NS as ViewerMenuNS } from '../components/viewer/Menu/ViewerMenu';
import EngineModule           from '../EngineModule';

export default () => EngineModule.all.find(x => x.id === 'viewer-menu') || new EngineModule.LogicalEngineModule({
	type: 'logical',
	id: 'viewer-menu',
	dependencies: [
		'oms-basket'
	],
	allowedCustomers: null,
	insertionPath: 'K.visualization.V',
	generateComponentConfiguration(): ViewerMenuNS.Configuration {
		return {
			mode: this.configuration.mode ?? 'contextual',
			buttons: {
				delete: {
					action: 'default'
				},
				edit: {
					action: 'default'
				},
				rotate: {
					action: 'default'
				}
			},
			generator: {
				componentPath: 'K',
				parameters: [],
				propertyPath: 'plannerMenuButtonGenerator',
				type: 'call'
			},
			isContextual: false
		};
	}
});
